import pageNotFoundImg from '@assets/status-pages/page_not_found.webp';
import { useLingui } from '@lingui/react/macro';
import StatusPage from '@routes/system/___shared___/components/status-page';
import { Text } from '@routes/system/___shared___/components/status-page/styled.tsx';

const NoSuchPage = () => {
    const { t } = useLingui();

    return (
        <StatusPage
            image={<img src={pageNotFoundImg} alt={t`page not found`} />}
            header={'404'}
            subheader={t`Page Not Found!`}
            content={<Text>{t`Page you are looking for doesn’t exist or has been moved.`}</Text>}
        />
    );
};

export default NoSuchPage;
